import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getPhotoUrl } from "../../../common/utils/getPhotoUrl";
import { getChatBlockUsers, getUserInfoByUuids } from "../apis/chatApi";
import { set as setCachedUser } from "../stores/userDisplayUtils";
import { enrichUsers, getUnresolvedUserIds } from "../utils/userMapping";

async function fetchBlockedUsers() {
  const res = await getChatBlockUsers();
  const list = Array.isArray(res) ? res : (res?.blockedUsers || []);

  // 캐시에 없는 유저 정보를 API로 조회 후 캐시에 저장
  const unresolvedIds = getUnresolvedUserIds(list);
  if (unresolvedIds.length > 0) {
    const users = await getUserInfoByUuids(unresolvedIds);
    users.forEach((u) => {
      if (u.uuid) {
        setCachedUser(u.uuid, {
          name: u.name || null,
          photo: getPhotoUrl(u.photo, "agent"),
        });
      }
    });
  }

  return enrichUsers(list);
}

export const blockedUsersQueryKey = ["blockedUsers"];

export function useChatBlockUsersLoad(onUsersLoaded, onError) {
  const query = useQuery({
    queryKey: blockedUsersQueryKey,
    queryFn: fetchBlockedUsers,
  });

  useEffect(() => {
    if (query.data) {
      onUsersLoaded?.(query.data);
    }
  }, [query.data, onUsersLoaded]);

  useEffect(() => {
    if (query.error) {
      onError?.(query.error.message || "차단 사용자 목록을 불러오지 못했습니다.");
    }
  }, [query.error, onError]);

  return query;
}
